import * as Styled from "./CatalogListItem.styled"

export function CatalogListItemSkeleton() {

    return <Styled.Skeleton />
}